<template>
  <div class="row">
    <div class="col-12">
      <div class="tile">
        <div class="form-inline">
          <client-select v-if="!client" class="mr-1 mb-1" :model="filterFormModel" attribute="client" @change="search"
                         :isFilter="true" :place-holder="$t('selectClient') "></client-select>

          <time-range-picker :model="filterFormModel" class="mr-1 mb-1" :label="$t('createTime')"></time-range-picker>
          <button @click="load" class="btn btn-primary mr-1 mb-1">{{ $t('search') }}</button>
          <button @click="reset" class="btn btn-secondary mr-1 mb-1">Reset</button>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="c-paging clearfix">
        <div class="c-paging__count" v-if="itemCount">
          {{ $t('found', [itemCount]) }}
        </div>
        <div class="c-paging__right">
          <div class="c-paging__numbers">
            <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                          v-model="filterFormModel.page" :total-rows="itemCount"
                          :per-page="filterFormModel.pageSize" @input="load"></b-pagination>

          </div>
        </div>
      </div>
    </div>
    <div class="col-12" v-if="!client">
      <div class="c-sorting"
           v-if="['admin', 'owner', 'account', 'operationsManager', 'tech'].includes($store.state.user.role)">
        <div class="row">
          <div class="col-lg-12 c-sorting__right">
            <div class="c-sorting__btn">
              <export :filter="filterFormModel" :total-count="itemCount"></export>

              <monthly-user-new></monthly-user-new>
              <monthly-user-more></monthly-user-more>
              <monthly-user-extend></monthly-user-extend>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12" v-if="items && items.length">
      <div class="c-smart-table tile">
        <!--          <div class="row">-->
        <!--            <div class="col-10">-->
        <!--              <b class="text-info text-right">{{ $t('total') }}</b>-->
        <!--            </div>-->
        <!--            <div class="col-2"><b-spinner v-if="totalLoading" small></b-spinner><span v-else>{{ total | numFormat }}</span></div>-->
        <!--          </div>-->
        <div class="row c-smart-table__title">
          <div class="col-lg-4">{{ $t('client') }}</div>
          <div class="col-lg-4">{{ $t('packageInfo') }}</div>
          <div class="col-lg-2">{{ $t('amount') }}</div>
          <div class="col-lg-2"></div>
        </div>
        <div class="row" v-for="item in items" :key="item._id">
          <div class="col-lg-4">
            <div>
              <b>{{ $t('client') }}: </b>
              <span v-if="item.client">{{ item.client.companyName }} ({{ item.client.domain }})</span>
              <span v-else>{{ $t('unknown') }}</span>
            </div>
            <div>
              <b>{{ $t('sales') }}: </b>
              <span v-if="item.sales">{{ item.sales.name }}</span>
              <span v-else class="small">{{ $t('notUpdated') }}</span>
            </div>
            <div>
              <label v-if="item.type" class="badge badge-primary">{{ $t(item.type) }}</label>
            </div>
          </div>
          <div class="col-lg-4">
            <div>
              <b>{{ $t('numberOfPackage') }}:&nbsp;</b>
              <span>{{ item.limit }}</span>
            </div>
            <div>
              <b>{{ $t('numberOfMonth') }}:&nbsp;</b>
              <span>{{ item.monthCount }}</span>
            </div>
            <div>
              <b>{{ $t('createTime') }}:&nbsp;</b>
              <span>{{ item.createTime | moment('DD/MM/YYYY') }}</span>
            </div>
            <div>
              <b>{{ $t('startTime') }}: </b>
              <span>{{ item.startTime | moment('DD/MM/YYYY') }}</span>
            </div>
            <div>
              <b>{{ $t('expireTime') }}: </b>
              <span>{{ item.expireTime | moment('DD/MM/YYYY HH:mm:ss') }}</span>
            </div>
            <div v-if="item.client">
              <b>{{ $t('activeTime') }}: </b>
              <span>{{ activeTime[item.client._id] | moment('DD/MM/YYYY HH:mm:ss') }}</span>
            </div>
            <div v-if="item.note">
              <b>{{ $t('note') }}: </b>
              <span>{{ item.note }}</span>
            </div>
          </div>
          <div class="col-lg-2">
            <div>
              <b class="c-smart-table__label">{{ $t('amount') }}: </b>
              <span>{{ item.total | numFormat }}</span>
            </div>
          </div>
          <div class="col-lg-2">
            <div class="text-center">
              <button v-if="['owner', 'account'].includes($store.state.user.role) && checkTimeRange(item.createTime)"
                      @click="openCancelPackageModal(item)" type="button" class="btn btn-sm btn-danger">
                <font-awesome-icon icon="ban"/>&nbsp;{{ $t('cancelPackage') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 text-center text-danger" v-if="!items.length">
      <span v-if="filterFormModel.page === 1 && !filterFormModel.keyword">{{ $t('notFoundCreate') }}</span>
      <span v-if="filterFormModel.page > 1 || filterFormModel.keyword">{{ $t('notFoundSearch') }}</span>
    </div>
    <div class="col-12" v-if="itemCount">
      <div class="c-paging__count" v-if="itemCount">
        {{ $t('found', [itemCount]) }}
      </div>
      <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                    v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize"
                    @input="load">
      </b-pagination>
    </div>

    <b-modal v-model="show" ok-only :title="$t('cancelPackage')">
      <div class="row">
        <div class="col-12">
          <p>
            <span>{{ $t('callMinutes') }}: </span>
            <b>{{ dataToCancelPackage.billDuration | callDuration }}</b>
          </p>
        </div>
      </div>
      <form-select :label="$t('refundType')" :model="model" attribute="refundType" :options="[
                        {text: this.$t('full'), value: 'full'},
                        {text: this.$t('partial'), value: 'partial'}
                      ]"></form-select>

      <template v-slot:modal-footer>
        <b-button variant="secondary" class="float-right" @click="show = false">
          {{ $t('cancel') }}
        </b-button>
        <b-button :disabled="refundLoading" variant="primary" class="float-right"
                  @click="refund(dataToCancelPackage.packageId, dataToCancelPackage._id)">
          <b-spinner v-if="refundLoading" small></b-spinner>
          {{ $t('refund') }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import List from "@/mixins/List";
import ClientSelect from "../../../components/ClientSelect";
import TimeRangePicker from "@/components/TimeRangePicker";
import _ from 'lodash';
import MonthlyUserNew from "./MonthlyUserNew";
import MonthlyUserMore from "./MonthlyUserMore";
import MonthlyUserExtend from "./MonthlyUserExtend";
import Export from "./ClientPackageExport";
import moment from 'moment'

export default {
  props: ['client'],
  components: {
    MonthlyUserMore, MonthlyUserExtend,
    MonthlyUserNew,
    ClientSelect, TimeRangePicker,
    Export
  },
  mixins: [List],
  data: function () {
    return {
      service: '/client-package',
      autoLoad: this.client ? true : false,
      defaultFilterFormModel: {
        client: this.client ? this.client._id : null
      },
      gatewayNames: [],
      total: 0,
      totalLoading: false,
      reloadBus: 'clientPackage',
      activeTime: {},
      show: false,
      dataToCancelPackage: {_id: null, billDuration: 0, packageId: null},
      model: {refundType: 'full'},
      refundLoading: false
    }
  },
  mounted() {
    this.load();
  },
  methods: {
    search: _.debounce(function () {
      this.filterFormModel.page = 1;
      this.load();
    }, 200),
    load: _.debounce(async function () {
      let loader = this.$loading.show();
      try {
        let response = await this.$service.get(this.service, {params: this.filterFormModel});
        this.apply(response.data);
        let ids = response.data.docs.map(item => item.client ? item.client._id : null);
        let _response = await this.$service.post('/client/first-plan-order', {ids});
        this.activeTime = {};
        _response.data.forEach(item => {
          this.activeTime[item._id] = item.confirmTime;
        });
      } catch (error) {
        if (error.response && error.response.data && error.response.data.message) {
          this.$swal({
            text: error.response.data.message,
            icon: 'error'
          });
        } else {
          if (error.message) {
            this.$swal({
              text: error.message,
              icon: 'error'
            });
          }
        }
      }
      loader.hide();
    }, 200, {leading: true, trailing: false}),
    // sum: function () {
    //   this.totalLoading = true;
    //   this.$bgService.get(this.service + "/sum", {params: this.filterFormModel}).then(response => {
    //     this.total = response.data && response.data.length > 0 ? response.data[0].total : 0;
    //   }).finally(()=> {
    //     this.totalLoading = false
    //   });
    // },
    openCancelPackageModal(item) {
      this.model.refundType = 'full'
      let loader = this.$loading.show();
      this.$service.get(this.service + '/call-package-minutes', {
        params: {
          client: item.client._id,
          packageCreateTime: item.createTime
        }
      }).then(response => {
        if (response.data && response.data.length) {
          this.dataToCancelPackage = response.data[0]
          this.dataToCancelPackage.packageId = item._id
        } else {
          this.dataToCancelPackage = {_id: item.client._id, billDuration: 0, packageId: item._id}
        }
      }).catch(error => {
        if (error.response && error.response.data && error.response.data.message) {
          this.$swal({
            text: error.response.data.message,
            icon: 'error'
          });
        } else {
          if (error.message) {
            this.$swal({
              text: error.message,
              icon: 'error'
            });
          }
        }
      }).finally(() => {
        loader.hide();
      });

      this.show = true
    },
    checkTimeRange(createTime) {
      let createAt = Number(moment(createTime).startOf('day').valueOf())
      let now = Number(moment().endOf('day').valueOf())
      let tenDaysInMilliseconds = 10 * 24 * 60 * 60 * 1000

      return now - createAt <= tenDaysInMilliseconds
    },
    refund(id, clientId) {
      this.$swal({
        title: this.$t('refund'),
        html: this.$t('refundAlert'),
        icon: "warning",
        showCancelButton: true
      }).then((result) => {
        if (result.value) {
          let loader = this.$loading.show();
          this.model.client = clientId
          this.model.billDuration = this.dataToCancelPackage.billDuration
          this.$service.post(this.service + '/refund/' + id, this.model).then(response => {
            if (response.data) {
              if (this.load) {
                this.load();
              }
              if (this.reloadBus) {
                this.$bus.$emit(this.reloadBus);
              }
              this.$swal({
                title: this.$t('success'),
                text: this.$t('refundSuccessful'),
                icon: 'success'
              });
            } else {
              this.$swal({
                title: this.$t('error'),
                text: this.$t('refundFailed'),
                icon: 'error'
              });
            }
          }).catch(error => {
            if (error.response && error.response.data && error.response.data.message) {
              this.$swal({
                text: error.response.data.message,
                icon: 'error'
              });
            } else {
              if (error.message) {
                this.$swal({
                  text: error.message,
                  icon: 'error'
                });
              }
            }
          }).finally(() => {
            loader.hide();
            this.show = false
          });
        }
      });
    }
  },
  i18n: {
    messages: {
      en: {
        numberOfPackage: 'Number of package',
        numberOfMonth: 'Number of month',
        startTime: 'Start time',
        expireTime: 'Expire time',
        amount: 'Amount',
        packageInfo: 'Package info',
        monthlyUser: 'Monthly user',
        monthlyChannel: 'Monthly channel',
        note: 'Note',
        activeTime: "Active time",
        sales: 'Sales',
        account: 'Account',
        cancelPackage: 'Cancel package',
        callMinutes: 'Number of minutes called',
        refundType: 'Refund method',
        partial: 'Refund according to call minutes',
        full: 'Refund full',
        refund: 'Refund',
        refundAlert: 'Are you sure you want to cancel the package and get a refund?',
        refundSuccessful: 'Refund successful',
        refundFailed: 'Refund failed'
      },
      vi: {
        numberOfPackage: 'Số gói',
        numberOfMonth: 'Số tháng',
        startTime: 'Ngày bắt đầu',
        expireTime: 'Ngày hết hạn',
        amount: 'Thành tiền',
        packageInfo: 'Thông tin gói',
        monthlyUser: 'TGU',
        monthlyChannel: 'TGC',
        note: 'Ghi chú',
        activeTime: "Kích hoạt lúc",
        sales: 'Sales',
        account: 'Chăm sóc',
        cancelPackage: 'Huỷ gói',
        callMinutes: 'Số phút đã gọi',
        refundType: 'Hình thức hoàn tiền',
        partial: 'Hoàn theo phút gọi',
        full: 'Hoàn toàn bộ',
        refund: 'Hoàn tiền',
        refundAlert: 'Bạn có chắc muốn huỷ gói và hoàn tiền không?',
        refundSuccessful: 'Hoàn tiền thành công',
        refundFailed: 'Hoàn tiền thất bại'
      }
    }
  }
}
</script>